import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import _isEqual from 'lodash/isEqual';
import _debounce from 'lodash/debounce';

import Loader from 'components/common/ui/Loader';
import UnifiedNav from 'components/common/header/UnifiedNav';
import UnificationNav from 'components/common/header/UnificationNav/UnificationNav';

import ChecklistHeader from './ChecklistHeader';
import ChecklistNav from './ChecklistNav';
import ChecklistTaskList from './ChecklistTaskList';
import ChecklistTask from './ChecklistTask';
import ChecklistEmptyState from './ChecklistEmptyState';

import './ChecklistV2.less';
import featureFlags from '../../../util/featureFlags';

class ChecklistV2Container extends Component {
  componentDidMount() {
    const { init } = this.props;

    init();
    window.addEventListener('resize', this.debouncify);
  }

  componentDidUpdate(prevProps) {
    const {
      location: { search: prevSearch },
    } = prevProps;
    const {
      location: { search },
      filterTasks,
    } = this.props;
    const filtersChanged = !_isEqual(prevSearch, search);

    if (filtersChanged) {
      filterTasks();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.debouncify);
  }

  debouncify = () => _debounce(() => this.forceUpdate(), 500);

  renderTaskView = () => {
    const { selectedTaskId, noFilterResults, clearFilters } = this.props;

    if (noFilterResults) {
      return (
        <ChecklistEmptyState
          className="checklist__emptyState"
          buttonCopy="Clear Filters"
          onClick={clearFilters}
        />
      );
    }
    if (selectedTaskId) {
      return <ChecklistTask />;
    }

    return (
      <ChecklistEmptyState
        className="checklist__emptyState"
        description="Select a task to get started"
      />
    );
  };

  renderLoadingOrContent = () => {
    const { loading } = this.props;

    if (loading)
      return (
        <div className="checklist__loader--wrap">
          <Loader />
        </div>
      );

    return (
      <Fragment>
        <ChecklistTaskList />
        <div id="checklistContainerRight" className="checklist__content--right">
          <div className="checklist__content--right__inner">{this.renderTaskView()}</div>
        </div>
      </Fragment>
    );
  };

  render() {
    return (
      <Fragment>
        {featureFlags.get('navRedesign') ? (
          <UnifiedNav disablePrimaryNavCollapse />
        ) : (
          <UnificationNav />
        )}
        <section id="checklistContainer" className="zola-ui checklist__container">
          <ChecklistHeader />
          <ChecklistNav />
          <main id="checklistMainContainer" className="checklist__main-container">
            {this.renderLoadingOrContent()}
          </main>
        </section>
      </Fragment>
    );
  }
}

ChecklistV2Container.propTypes = {
  init: PropTypes.func,
  selectedTaskId: PropTypes.string,
  noFilterResults: PropTypes.bool,
  loading: PropTypes.bool,
  clearFilters: PropTypes.func,
};

ChecklistV2Container.defaultProps = {
  init: () => {},
  loading: false,
  noFilterResults: false,
};

export default ChecklistV2Container;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistV2Container.jsx